export default function createEnvironments(baseUrl: string, userManagementUrl?: string, prodUserManagementUrl?: string) {
  const apiEndpoint = '/api';

  const createUrl = (urlPath: string, urlPrefix: string = baseUrl) => {
    // normalize prefix and path parts to avoid double slashes
    const prefix = urlPrefix.endsWith('/') ? urlPrefix : urlPrefix + '/';
    const path = urlPath
      .split('/')
      .filter((el) => el.length > 0)
      .join('/');
    return `${prefix}${path}`;
  };

  return {
    production: false,
    apiBaseUrl: baseUrl,

    products: {
      get: createUrl(apiEndpoint + '/runtech/products'),
      fields: {
        fetch: createUrl(apiEndpoint + '/runtech/products/features'),
      },
      exactModel: createUrl(apiEndpoint + '/runtech/products/find-models'),
      specificModel: createUrl(apiEndpoint + '/runtech/products/specific-model?specificModel={specificModel}'),
    },
    blowersTypes: {
      get: createUrl(apiEndpoint + '/runtech/products/blower-groups-and-types'),
    },
    getAllModels: {
      get: createUrl(apiEndpoint + '/runtech/products/models'),
    },
    units: {
      formulas: createUrl(apiEndpoint + '/runtech/unit'),
    },
    login: {
      apiEndpoint: userManagementUrl + '/api/v3/login',
      logout: userManagementUrl + '/api/v3/logout',
    },
    user: {
      recoverPassword: userManagementUrl + '/api/v2/user/productselection/resetpassword',
      resetPassword: userManagementUrl + '/api/v2/user/{username}/resetpassword/{token}',
      checkResetPasswordToken: userManagementUrl + '/api/v2/user/check/{username}/{token}',
    },
  };
}
